import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { Theme, styled } from "@mui/material/styles";

import { BannerFrame } from "@/components/Casino/Banner/styles";
import { MASCOT_PALETTE } from "@/components/Others/MascotPanel";
import { colors } from "@/theme";

import {
  SPORT_BANNER_ASPECT_RATIO,
  SPORT_BANNER_ASPECT_RATIO_MOBILE,
} from "../../data/sportBanners";

/* The sport banner carousel at the top of a page. */

export const BannerContent = styled(Stack)({
  padding: "12px",
  color: colors.white,
  textShadow: "0 1px 6px rgba(0,0,0,0.6)",
  "@media (min-width: 900px)": {
    padding: "20px",
  },
});

const sportBannerAspect = (theme: Theme) => ({
  aspectRatio: SPORT_BANNER_ASPECT_RATIO,
  [theme.breakpoints.down("sm")]: { aspectRatio: SPORT_BANNER_ASPECT_RATIO_MOBILE },
});

/** The sport banner carousel: the game banner's frame with the sport pages' corners. */
export const SportBannerRoot = styled(BannerFrame)({
  borderRadius: 12,
});

/** The carousel's track; its slides take the banner's shape. */
export const SportSliderTrack = styled(Box)(({ theme }) => sportBannerAspect(theme));

export const SportSlide = styled(Box)(({ theme }) => ({
  ...sportBannerAspect(theme),
  position: "relative",
  overflow: "hidden",
  borderRadius: 12,
  backgroundColor: MASCOT_PALETTE.night,
}));

/** A page's own title over the pictures; lets the pointer through so they still drag. */
export const SportSlideOverlay = styled(Box)({
  position: "absolute",
  inset: 0,
  zIndex: 1,
  display: "flex",
  alignItems: "flex-end",
  pointerEvents: "none",
});

/**
 * The picture, filling the slide.
 *
 * The wide shape shows a band of a picture made taller than it, so the band is
 * taken from above the middle, where a banner's title and face are. The phone
 * shape is close to the picture's own and takes its centre.
 */
export const SportSlideImage = styled(Box, {
  shouldForwardProp: (prop) => prop !== "backgroundUrl",
})<{ backgroundUrl: string }>(({ theme, backgroundUrl }) => ({
  position: "absolute",
  inset: 0,
  backgroundImage: backgroundUrl ? `url("${backgroundUrl}")` : "none",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "50% 28%",
  [theme.breakpoints.down("sm")]: { backgroundPosition: "center" },
}));
